(function(){
function post(url,body){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})}
function prev(box){var fi=box.querySelector('.samdia-fi');if(!fi)return;
  var nm=fi.querySelector('[data-fl-name]').value.trim().toUpperCase(),nu=fi.querySelector('[data-fl-num]').value.trim();
  var bt=(fi.querySelector('[data-fl-bottom]')||{value:''}).value.trim().toUpperCase(),tb=fi.querySelector('[data-prev-bottom]');
  var tn=fi.querySelector('[data-prev-name]'),tu=fi.querySelector('[data-prev-num]'),th=fi.querySelector('[data-prev-hint]');
  tn.textContent=nm;tu.textContent=nu;th.style.display=(nm||nu||bt)?'none':'';
  if(tb){tb.textContent=bt;tb.setAttribute('font-size',bt.length>10?Math.max(8,Math.floor(120/(bt.length*.7))):13)}
  tn.setAttribute('font-size',nm.length>8?Math.max(11,Math.floor(170/nm.length)):20);
  tu.setAttribute('font-size',nu.length>=3?50:64);
  if(nm&&!nu)tn.setAttribute('y',110);else tn.setAttribute('y',70);
  if(!nm&&nu)tu.setAttribute('y',115);else tu.setAttribute('y',138)}
document.addEventListener('change',function(e){
  var i=e.target;if(!i.matches)return;
  if(i.matches('[data-flocage]')){var box=i.closest('[data-samdia-options]'),fi=box.querySelector('.samdia-fi');fi.hidden=!i.checked;
    fi.querySelectorAll('input').forEach(function(x){x.disabled=!i.checked});
    if(i.checked){var f=fi.querySelector('[data-fl-name]');try{f.focus({preventScroll:true})}catch(x){}}prev(box)}
},true);
document.addEventListener('input',function(e){
  var t=e.target;if(!t.matches)return;
  if(t.matches('[data-fl-num]'))t.value=t.value.replace(/\D/g,'').slice(0,3);
  else if(t.matches('[data-fl-name]'))t.value=t.value.replace(/[^\p{L} '.\-]/gu,'').toUpperCase().slice(0,12);
  else if(t.matches('[data-fl-bottom]'))t.value=t.value.replace(/[^\p{L}0-9 '.&\/\-]/gu,'').toUpperCase().slice(0,16);
  else return;
  prev(t.closest('[data-samdia-options]'))});
/* Short (option) : afficher les tailles et pr\u00e9-s\u00e9lectionner celle du maillot */
document.addEventListener('change',function(e){
  var i=e.target;if(!i.matches||!i.matches('[data-short]'))return;
  var box=i.closest('[data-samdia-options]'),sb=box&&box.querySelector('[data-short-box]');if(!sb)return;
  sb.hidden=!i.checked;if(!i.checked||sb.hasAttribute('data-single'))return;
  var rs=sb.querySelectorAll('input[data-short-size]'),any=false;rs.forEach(function(r){if(r.checked)any=true});
  if(any)return;var cs=chosenSize(box.closest('.product__info-container')||document).toLowerCase();
  for(var k=0;k<rs.length;k++){if(!rs[k].disabled&&String(rs[k].getAttribute('data-name')).toLowerCase()===cs){rs[k].checked=true;break}}
},true);
/* Version Player : disponible dans toutes les tailles (S \u00e0 4XL) */
function chosenSize(scope){var v='';
  /* boutons : l'input porte data-option-name="Taille" (nom "Taille-1") ; menu d\u00e9roulant : select name="options[Taille]" */
  scope.querySelectorAll('input[type=radio]:checked').forEach(function(r){var n=r.getAttribute('data-option-name')||'';if(/taille|size/i.test(n))v=r.value});
  scope.querySelectorAll('select[name^="options["]').forEach(function(s){if(/taille|size/i.test(s.name))v=s.value});
  return v}
function syncPlayer(){
  document.querySelectorAll('[data-samdia-options]').forEach(function(box){
    var pr=box.querySelector('input[name=samdia-player]:not([value=""])');if(!pr)return;
    pr.disabled=pr.getAttribute('data-avail')==='0';
    var lab=pr.closest('label');if(lab)lab.classList.toggle('samdia-off',pr.disabled);
    if(pr.disabled&&pr.checked){var st=box.querySelector('input[name=samdia-player][value=""]');if(st)st.checked=true}})}
document.addEventListener('change',function(){setTimeout(syncPlayer,0)},true);
/* Ajout au panier : maillot + flocage + patch + version player */
document.addEventListener('submit',function(e){
  var f=e.target;if(!f.matches||!f.matches('form[action*="/cart/add"]'))return;
  var scope=f.closest('.product__info-container')||document,box=scope.querySelector('[data-samdia-options]');
  if(!box)return;
  var cb=box.querySelector('[data-flocage]'),pt=box.querySelector('input[name=samdia-patch]:checked'),pl=box.querySelector('input[name=samdia-player]:checked');
  var sh=box.querySelector('[data-short]'),hasShort=!!(sh&&sh.checked);
  var hasFl=!!(cb&&cb.checked),hasPatch=!!(pt&&pt.value),hasPlayer=!!(pl&&pl.value);
  if(!hasFl&&!hasPatch&&!hasPlayer&&!hasShort)return;
  e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
  var err=box.querySelector('[data-samdia-err]');
  function fail(m){err.textContent=m;err.hidden=false}
  err.hidden=true;
  var fd=new FormData(f),qty=parseInt(fd.get('quantity'),10)||1,title=box.getAttribute('data-title')||'';
  var grp=Date.now().toString(36)+Math.random().toString(36).slice(2,6);
  var main={id:parseInt(fd.get('id'),10),quantity:qty,properties:{'_groupe':grp}};
  var items=[main];
  if(hasFl){
    var fi=box.querySelector('.samdia-fi'),nm=fi.querySelector('[data-fl-name]').value.trim().toUpperCase(),nu=fi.querySelector('[data-fl-num]').value.trim();
    var bt=(fi.querySelector('[data-fl-bottom]')||{value:''}).value.trim().toUpperCase();
    if(!nm&&!nu&&!bt)return fail('Indiquez un nom, un num\u00e9ro ou un texte pour le flocage.');
    if(nu&&!/^[0-9]{1,3}$/.test(nu))return fail('Le num\u00e9ro doit faire 3 chiffres maximum.');
    if(nm)main.properties['Flocage nom']=nm;if(nu)main.properties['Flocage num\u00e9ro']=nu;if(bt)main.properties['Flocage bas']=bt;
    var fp={'Maillot':title,'_groupe':grp};if(nm)fp['Nom']=nm;if(nu)fp['Num\u00e9ro']=nu;if(bt)fp['Texte du bas']=bt;
    items.push({id:parseInt(fi.getAttribute('data-flocage-id'),10),quantity:qty,properties:fp})}
  if(hasPlayer){
    main.properties['Version']='Player';
    items.push({id:parseInt(pl.value,10),quantity:qty,properties:{'Maillot':title,'_groupe':grp}})}
  if(hasShort){
    var sb=box.querySelector('[data-short-box]'),sid,snm;
    if(sb.hasAttribute('data-single')){sid=parseInt(sb.getAttribute('data-short-id'),10);snm=chosenSize(scope)}
    else{var sr=sb.querySelector('input[data-short-size]:checked');if(!sr)return fail('Choisis la taille du short.');sid=parseInt(sr.value,10);snm=sr.getAttribute('data-name')}
    main.properties['Short']=snm?('Oui, taille '+snm):'Oui';
    var shp={'Maillot':title,'_groupe':grp};if(snm)shp['Taille short']=snm;
    items.push({id:sid,quantity:qty,properties:shp})}
  if(hasPatch){
    main.properties['Patch']=pt.getAttribute('data-name');
    items.push({id:parseInt(pt.value,10),quantity:qty,properties:{'Maillot':title,'_groupe':grp}})}
  var btn=f.querySelector('[type=submit]');if(btn)btn.disabled=true;
  post('/cart/add.js',{items:items})
    .then(function(r){if(!r.ok)return r.json().then(function(j){throw new Error(j.description||'Erreur')});location.href='/cart'})
    .catch(function(x){if(btn)btn.disabled=false;fail(x.message||'Impossible d\'ajouter au panier.')});
},true);
/* Panier : les lignes d'un m\u00eame maillot (flocage, patch) bougent ensemble */
function rowsOf(row){var g=row.getAttribute('data-samdia-group');return g?document.querySelectorAll('[data-samdia-group="'+g+'"]'):[row]}
function updateGroup(row,qty){var u={};rowsOf(row).forEach(function(r){u[r.getAttribute('data-samdia-key')]=qty});
  post('/cart/update.js',{updates:u}).then(function(){location.reload()})}
document.addEventListener('click',function(e){
  var rm=e.target.closest&&e.target.closest('cart-remove-button');if(!rm)return;
  var row=rm.closest('[data-samdia-key]');if(!row||!row.getAttribute('data-samdia-group'))return;
  e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();updateGroup(row,0)},true);
document.addEventListener('change',function(e){
  var i=e.target;if(!i.matches||!i.matches('.quantity__input'))return;
  var row=i.closest('[data-samdia-key]');if(!row||!row.getAttribute('data-samdia-group'))return;
  e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();updateGroup(row,parseInt(i.value,10)||0)},true);

/* Cache l'option "Flocage" des variantes (Sans flocage / Avec flocage) : le flocage se choisit avec le bloc "Flocage nom + num\u00e9ro" */
function hideFlo(){
  var seen={};
  document.querySelectorAll('select[name^="options["],input[type=radio][data-option-name]').forEach(function(el){
    var n=el.getAttribute('data-option-name')||el.getAttribute('name')||'';if(!/flocage/i.test(n))return;
    var w=el.closest('.product-form__input');if(!w||w.classList.contains('samdia-hide'))return;
    w.classList.add('samdia-hide');w.style.display='none'
  });
}
/* Tri des tailles : XS, S, M, L, XL, XXL, 3XL... (et tailles enfants par ordre croissant) */
var SZR={'xxs':0,'xs':1,'s':2,'m':3,'l':4,'xl':5,'xxl':6,'2xl':6,'xxxl':7,'3xl':7,'xxxxl':8,'4xl':8,'5xl':9,'6xl':10};
function szRank(v){var t=String(v||'').toLowerCase().replace(/\s+/g,'');if(SZR.hasOwnProperty(t))return SZR[t];
  var p=t.match(/\((xxs|xs|s|m|l|xl|xxl|2xl|3xl|4xl)\)/);if(p)return SZR[p[1]]-0.5;
  var n=parseFloat(t);if(!isNaN(n))return 100+n;return 1000}
function sortedIdx(items){var a=items.map(function(it,i){return{i:i,r:szRank(it.v)}});a.sort(function(x,y){return x.r-y.r||x.i-y.i});return a.map(function(x){return x.i})}
function isSorted(ix){for(var k=0;k<ix.length;k++)if(ix[k]!==k)return false;return true}
function sortSizes(){
  document.querySelectorAll('.product-form__input--pill').forEach(function(fs){
    var lg=fs.querySelector('legend');if(!lg||!/taille|size/i.test(lg.textContent))return;
    var items=[];fs.querySelectorAll('input[type=radio]').forEach(function(r){var l=fs.querySelector('label[for="'+r.id+'"]');if(l)items.push({v:r.value,a:r,b:l})});
    if(items.length<2)return;var ix=sortedIdx(items);if(isSorted(ix))return;
    var last=items[0].b;items.forEach(function(it){if(last.compareDocumentPosition(it.b)&4)last=it.b});
    var ref=last.nextSibling;ix.forEach(function(k){fs.insertBefore(items[k].a,ref);fs.insertBefore(items[k].b,ref)})});
  document.querySelectorAll('.product-form__input--dropdown').forEach(function(w){
    var lb=w.querySelector('label'),sel=w.querySelector('select');if(!lb||!sel||!/taille|size/i.test(lb.textContent))return;
    var items=Array.prototype.map.call(sel.options,function(o){return{v:o.value,o:o}});if(items.length<2)return;
    var ix=sortedIdx(items);if(isSorted(ix))return;ix.forEach(function(k){sel.appendChild(items[k].o)})});
}
function tidy(){hideFlo();sortSizes();syncPlayer()}
document.addEventListener('DOMContentLoaded',tidy);tidy();
var _t;new MutationObserver(function(){clearTimeout(_t);_t=setTimeout(tidy,50)}).observe(document.documentElement,{childList:true,subtree:true});
})();

/* Samdia : récapitulatif du prix des options (fiche produit) */
(function(){
function eur(c){return (c/100).toFixed(2).replace('.',',')+' €'}
function parsePrice(t){var m=String(t||'').replace(/[\s ]/g,'').match(/(\d+(?:[.,]\d{1,2})?)/);return m?parseFloat(m[1].replace(',','.')):NaN}
function basePrice(scope){
  var el=scope.querySelector('.price__container .price-item--last')||scope.querySelector('.price .price-item--regular');
  var v=el?parsePrice(el.textContent):NaN;return isNaN(v)?null:Math.round(v*100)}
function recap(box){
  var rc=box.querySelector('[data-samdia-recap]');if(!rc)return;
  var sum=0,any=false;
  function add(el){var p=parseInt(el&&el.getAttribute('data-price'),10);if(!isNaN(p)){sum+=p;any=true}}
  var fl=box.querySelector('[data-flocage]');if(fl&&fl.checked)add(fl);
  var sh=box.querySelector('[data-short]');if(sh&&sh.checked)add(sh);
  var pl=box.querySelector('input[name=samdia-player]:checked');if(pl&&pl.value)add(pl);
  var pt=box.querySelector('input[name=samdia-patch]:checked');if(pt&&pt.value)add(pt);
  var scope=box.closest('.product__info-container')||document;
  var q=scope.querySelector('input[name=quantity]'),qty=Math.max(1,parseInt(q&&q.value,10)||1);
  var base=basePrice(scope);
  var key=any?[sum,qty,base].join('|'):'';
  if(rc.__k===key)return;rc.__k=key;
  rc.hidden=!any;if(!any)return;
  rc.querySelector('[data-recap-opt]').textContent='+'+eur(sum*qty);
  var row=rc.querySelector('[data-recap-totalrow]');
  if(base===null){row.hidden=true;return}
  row.hidden=false;
  rc.querySelector('[data-recap-totallabel]').textContent=qty>1?('Total ('+qty+' articles)'):'Total';
  rc.querySelector('[data-recap-total]').textContent=eur((base+sum)*qty)}
function all(){document.querySelectorAll('[data-samdia-options]').forEach(recap)}
document.addEventListener('change',function(){setTimeout(all,0)},true);
document.addEventListener('input',function(e){if(e.target&&e.target.name==='quantity')setTimeout(all,0)},true);
document.addEventListener('DOMContentLoaded',all);all();
var _r;new MutationObserver(function(){clearTimeout(_r);_r=setTimeout(all,60)}).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
})();

/* Samdia : case « J'accepte les CGV » avant le paiement (panier + tiroir panier) */
(function(){
var KEY='samdia_cgv';
function saved(){try{return sessionStorage.getItem(KEY)==='1'}catch(e){return false}}
function save(v){try{sessionStorage.setItem(KEY,v?'1':'0')}catch(e){}}
function boxes(){return document.querySelectorAll('[data-cgv-input]')}
function hideErr(){document.querySelectorAll('[data-cgv-err]').forEach(function(e){e.hidden=true})}
function sync(){var on=saved();boxes().forEach(function(b){if(!b.dataset.cgvInit){b.dataset.cgvInit='1';b.checked=on}})}
document.addEventListener('change',function(e){
  var t=e.target;if(!t||!t.matches||!t.matches('[data-cgv-input]'))return;
  save(t.checked);boxes().forEach(function(b){b.checked=t.checked});if(t.checked)hideErr();
});
document.addEventListener('click',function(e){
  var btn=e.target.closest&&e.target.closest('button[name="checkout"],input[name="checkout"]');
  if(!btn)return;
  var box=null,n=btn;
  while(n&&!box){n=n.parentElement;if(n&&n.querySelector)box=n.querySelector('[data-cgv-input]')}
  if(!box)return;
  if(box.checked)return;
  e.preventDefault();e.stopPropagation();
  var wrap=box.closest('[data-cgv]'),err=wrap&&wrap.querySelector('[data-cgv-err]');
  if(err)err.hidden=false;
  try{box.focus()}catch(x){}
},true);
var _c;new MutationObserver(function(){clearTimeout(_c);_c=setTimeout(sync,30)}).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('DOMContentLoaded',sync);sync();
})();

/* v57 : en-tête qui prend une ombre au défilement + barre « Ajouter au panier » collée en bas */
(function(){
var de=document.documentElement,tk=false;
function sc(){tk=false;de.classList.toggle('samdia-scrolled',(window.pageYOffset||de.scrollTop)>8)}
window.addEventListener('scroll',function(){if(!tk){tk=true;requestAnimationFrame(sc)}},{passive:true});sc();
function init(){
  if(document.querySelector('.samdia-sticky')||!/\/products\//.test(location.pathname))return;
  var btn=document.querySelector('product-form .product-form__submit, .product .product-form__submit');
  if(!btn||btn.closest('.quick-add')||btn.closest('.card-wrapper'))return;
  var info=btn.closest('.product__info-container')||document;
  var h=document.querySelector('.product__title h1');
  var bar=document.createElement('div');bar.className='samdia-sticky';bar.setAttribute('aria-hidden','true');
  bar.innerHTML='<div class="samdia-sticky__in"><div class="samdia-sticky__info"><span class="samdia-sticky__name"></span><span class="samdia-sticky__price"></span></div><button type="button" class="button button--primary samdia-sticky__btn" tabindex="-1">Ajouter au panier</button></div>';
  document.body.appendChild(bar);document.body.classList.add('samdia-has-sticky');
  var nm=bar.querySelector('.samdia-sticky__name'),pr=bar.querySelector('.samdia-sticky__price'),go=bar.querySelector('.samdia-sticky__btn');
  nm.textContent=h?h.textContent.replace(/\s+/g,' ').trim():document.title;
  function price(){
    var tot=info.querySelector('[data-recap-total]'),t='';
    if(tot&&!tot.closest('[hidden]')&&tot.textContent.trim())t=tot.textContent.trim();
    else{var p=info.querySelector('.price__container .price-item--last, .price-item--last');t=p?p.textContent.replace(/\s+/g,' ').trim():''}
    if(pr.textContent!==t)pr.textContent=t}
  price();
  var mo=new MutationObserver(price);mo.observe(info===document?document.body:info,{childList:true,subtree:true,characterData:true});
  var on=false;
  function set(v){if(on===v)return;on=v;bar.classList.toggle('is-on',v)}
  function sold(){return btn.disabled||btn.hasAttribute('disabled')}
  var vis=true;
  function upd(){set(!vis&&!sold())}
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){vis=es[0].isIntersecting;upd()},{threshold:0}).observe(btn);
    new MutationObserver(upd).observe(btn,{attributes:true,attributeFilter:['disabled']});
  }
  go.addEventListener('click',function(){
    if(sold())return;
    btn.click();
    setTimeout(function(){var er=document.querySelector('[data-samdia-err]');
      if(er&&!er.hidden&&er.textContent.trim())er.scrollIntoView({behavior:'smooth',block:'center'})},250)});
}
/* Panier : cases à cocher sur les articles, "Tout sélectionner" et "Supprimer la sélection" */
var selKeys={},selTm=0,selT=0;
function selGroup(row){var g=row.getAttribute('data-samdia-group');return g?document.querySelectorAll('[data-samdia-group="'+g+'"]'):[row]}
function selRowsOf(tb){return tb.querySelectorAll('tr.cart-item[data-samdia-key]')}
function selTxt(d,t){var e=d.querySelector('[data-t]');if(e&&e.textContent!==t)e.textContent=t}
function selUpdate(){
  document.querySelectorAll('.samdia-selbar').forEach(function(bar){
    var tb=bar.nextElementSibling;if(!tb||tb.tagName!=='TABLE')return;
    var rows=selRowsOf(tb),n=0;
    rows.forEach(function(r){var i=r.querySelector('[data-samdia-sel]');if(i&&i.checked)n++;r.classList.toggle('samdia-selected',!!(i&&i.checked))});
    var all=bar.querySelector('[data-samdia-selall]'),d=bar.querySelector('[data-samdia-seldel]');
    all.checked=rows.length>0&&n===rows.length;all.indeterminate=n>0&&n<rows.length;
    d.hidden=n===0;d.classList.remove('is-confirm');selTxt(d,'Supprimer la sélection ('+n+')')})}
function selBox(row){
  var c=row.querySelector('.cart-item__image-container')||row.querySelector('.cart-item__media');if(!c||row.querySelector('.samdia-sel'))return;
  var key=row.getAttribute('data-samdia-key'),nm=row.querySelector('.cart-item__name');
  var lab=document.createElement('label');lab.className='samdia-sel';
  var inp=document.createElement('input');inp.type='checkbox';inp.setAttribute('data-samdia-sel',key);
  inp.setAttribute('aria-label','Sélectionner '+(nm?nm.textContent.trim():'cet article'));inp.checked=!!selKeys[key];
  var sp=document.createElement('span');sp.className='samdia-selbox';sp.setAttribute('aria-hidden','true');
  lab.appendChild(inp);lab.appendChild(sp);c.insertBefore(lab,c.firstChild)}
function selNeeds(){
  var ts=document.querySelectorAll('table.cart-items');
  for(var k=0;k<ts.length;k++){var rs=selRowsOf(ts[k]);if(!rs.length)continue;
    var pv=ts[k].previousElementSibling;if(!(pv&&pv.classList.contains('samdia-selbar')))return true;
    for(var j=0;j<rs.length;j++)if(!rs[j].querySelector('.samdia-sel'))return true}
  return false}
function selEnsure(){
  document.querySelectorAll('table.cart-items').forEach(function(tb){
    var rows=selRowsOf(tb);if(!rows.length)return;
    rows.forEach(selBox);
    var pv=tb.previousElementSibling;
    if(!(pv&&pv.classList.contains('samdia-selbar'))){
      var bar=document.createElement('div');bar.className='samdia-selbar';
      bar.innerHTML='<label class="samdia-selall"><input type="checkbox" data-samdia-selall><span class="samdia-selbox" aria-hidden="true"></span><span>Tout sélectionner</span></label><button type="button" class="samdia-seldel" data-samdia-seldel hidden><span data-t>Supprimer la sélection (0)</span></button>';
      tb.parentNode.insertBefore(bar,tb)}});
  selUpdate()}
function selSoon(){if(selT)return;selT=setTimeout(function(){selT=0;if(selNeeds())selEnsure()},60)}
document.addEventListener('change',function(e){
  var i=e.target;if(!i||!i.matches)return;
  if(i.matches('[data-samdia-sel]')){
    e.stopPropagation();selKeys[i.getAttribute('data-samdia-sel')]=i.checked;selUpdate()}
  else if(i.matches('[data-samdia-selall]')){
    e.stopPropagation();var bar=i.closest('.samdia-selbar'),tb=bar&&bar.nextElementSibling;if(!tb)return;
    selRowsOf(tb).forEach(function(r){var c=r.querySelector('[data-samdia-sel]');if(c){c.checked=i.checked;selKeys[c.getAttribute('data-samdia-sel')]=i.checked}});
    selUpdate()}
},true);
document.addEventListener('click',function(e){
  var d=e.target.closest&&e.target.closest('[data-samdia-seldel]');if(!d)return;
  e.preventDefault();e.stopPropagation();
  var bar=d.closest('.samdia-selbar'),tb=bar&&bar.nextElementSibling;if(!tb)return;
  var u={},n=0;
  selRowsOf(tb).forEach(function(r){var c=r.querySelector('[data-samdia-sel]');
    if(c&&c.checked){n++;selGroup(r).forEach(function(x){u[x.getAttribute('data-samdia-key')]=0})}});
  if(!n)return;
  if(!d.classList.contains('is-confirm')){
    d.classList.add('is-confirm');selTxt(d,'Confirmer la suppression ('+n+')');
    clearTimeout(selTm);selTm=setTimeout(selUpdate,4000);return}
  d.disabled=true;
  fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:u})}).then(function(){location.reload()},function(){d.disabled=false;selUpdate()})
},true);
function selInit(){selSoon();if('MutationObserver' in window)new MutationObserver(selSoon).observe(document.body,{childList:true,subtree:true})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',selInit);else selInit();
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
